import React from "react";
import { useHistory } from "react-router-dom";
// Comps
import { IonIcon } from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
// Css
import classes from "./MarginContainer.module.scss";

interface Props {
  children: React.ReactNode;
  className?: string;
  hasBackBtn?: boolean;
}

const MarginContainer: React.FC<Props> = ({
  children,
  className,
  hasBackBtn = true,
}) => {
  const history = useHistory();

  return (
    <React.Fragment>
      <img
        className={classes.image}
        src="assets/img/common/AU_FG_Texture-1.jpg"
        alt=""
      />
      <div className={classes.outter_container}>
        <div className={`${classes.inner_container} ${className}`}>
          {hasBackBtn && (
            <IonIcon
              onClick={history.goBack}
              className={classes.back_icon}
              icon={chevronBackOutline}
            />
          )}
          {children}
        </div>
      </div>
    </React.Fragment>
  );
};

export default MarginContainer;
